import React from "react"
import types from "prop-types"
import * as API from "services/api"
import { useSelector, useDispatch } from "react-redux"
import {
  disableTaskNotifySetting,
  enableTaskNotifySetting,
  isTaskNotifySettingEnabled,
} from "reduxSlices/currentSettingsSlice"
import ItemRow from "shared/ItemRow"
import Switch from "shared/Switch"
import { errorToast } from "shared/toast"

const UPDATE_ERROR_MESSAGE = "Something went wrong. Unable to update task notification setting."

const NotificationSetting = ({ label, settingType }) => {
  const isEnabled = useSelector(isTaskNotifySettingEnabled(settingType))
  const dispatch = useDispatch()

  const enable = (type) => async () => {
    const response = await API.enableNotificationSetting({ settingType: type })

    if (response.ok) {
      dispatch(enableTaskNotifySetting(type))
    } else {
      errorToast(UPDATE_ERROR_MESSAGE)
    }
  }

  const disable = (type) => async () => {
    const response = await API.disableNotificationSetting({ settingType: type })

    if (response.ok) {
      dispatch(disableTaskNotifySetting(type))
    } else {
      errorToast(UPDATE_ERROR_MESSAGE)
    }
  }

  return (
    <ItemRow
      itemRowHeaderContent={(
        <>
          <span>{label}</span>
          <Switch
            checked={isEnabled}
            onChange={isEnabled ? disable(settingType) : enable(settingType)}
          />
        </>
      )}
    />
  )
}

NotificationSetting.propTypes = {
  label: types.string.isRequired,
  settingType: types.string.isRequired,
}

export default NotificationSetting
